const locale = {
  GUEST_DISPLAYNAME: 'Invitado',
  LOCATION: 'Institución',
  DEFAULT_LOCATION: 'Ontario, Canadá',
  INFO_POPOVER_STUDENT_LOCATION: 'Institución',
  INFO_POPOVER_PROFILE: 'Purdue University',
  ADMIN_PROFILE: 'Admin',
  NO_MAJORS_LENGTH: 'No hay información de campos laborales',
  NO_ACADEMIC_PROGRAMS: 'No hay información de programas académicos',
  ADD_MAJOR: 'Agrega tu primer campo laboral',
  ADD_ACADEMIC_PROGRAM: 'Agrega tu primer programa académico',
};

export default locale;
